import { Deserializable } from '../protocols/deserializable';
import { UpdateLegalFiduciarySubmissionData } from './update-legal-fiduciary-submission-data';

export class UpdateLegalFiduciarySubmission implements Deserializable {
  public new!: UpdateLegalFiduciarySubmissionData;
  public previous!: UpdateLegalFiduciarySubmissionData;
  public legalFiduciarySubmissionId!: string;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;
    if (!!this.new) {
      this.new = Deserialize.instanceOf(UpdateLegalFiduciarySubmissionData, this.new);
    }

    if (!!this.previous) {
      this.previous = Deserialize.instanceOf(UpdateLegalFiduciarySubmissionData, this.previous);
    }
  }
}
